@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@import 'variables';

.searchWrapper {
  display: flex;
  justify-content: center;

  .searchBox {
    padding:  hevo-toolkit-variables.$spacer * 0.75  $searcharea-padding-x;
    border: solid var(--border-width) var(--divider-color) !important;
    border-radius:  hevo-toolkit-variables.$border-radius-md;
    background:  hevo-toolkit-variables.$surface-bg !important;
    width: 500px;
    position: relative;
    cursor: pointer;

    .icon {
      margin-right:  hevo-toolkit-variables.$spacer * 0.75;
      margin-left:  hevo-toolkit-variables.$spacer * 0.06;
      color: inherit;
    }

    .actionButton {
      position: absolute;
      right:  hevo-toolkit-variables.$spacer * 0.75;
    }
  }

  &.noBorder {
    .searchBox {
      border-color: transparent !important;
    }
  }

  &.collapsible {
    max-width: 250px;
    width: 100%;

    .searchBox {
      max-width: 250px;
      width: 100%;
      padding:  hevo-toolkit-variables.$spacer * 0.5  hevo-toolkit-variables.$spacer;
    }

    input {
      padding: 0 !important;
      height:  hevo-toolkit-variables.$spacer !important;
      width: auto;
    }

    .icon {
      margin-right:  hevo-toolkit-variables.$spacer * 0.5;
    }
  }

  &.fullWidth {
    width: 100%;
    max-width: 100%;

    .searchBox {
      width: 100%;
      max-width: 100%;
    }
  }

  &.filled {
    .searchBox {
      background-color:  hevo-toolkit-variables.$default-bg !important;
      border-color:  hevo-toolkit-variables.$default-bg !important;
    }
  }
}
